export function buildSyncSuccessMessage(result) {
  const stats = result?.stats || {}
  const fragments = [
    `fetched: ${Number(stats.fetched || 0)}`,
    `created: ${Number(stats.created || 0)}`,
    `updated: ${Number(stats.updated || 0)}`,
    `skipped: ${Number(stats.skipped || 0)}`,
    `failed: ${Number(stats.failed || 0)}`,
  ]

  if (Number(stats.durationMs || 0) > 0) {
    fragments.push(`duration: ${Number(stats.durationMs)}ms`)
  }

  return fragments.join(', ')
}

export function normalizeErrorMessage(err, fallback) {
  if (err?.status === 401 || err?.status === 403) {
    return 'Access denied. Admin permissions are required.'
  }
  return err?.message || fallback
}

export function createDefaultFilters() {
  return {
    baseCurrency: '',
    quoteCurrency: '',
    source: '',
    status: 'all',
    rateDate: '',
    includeDerived: true,
    usedOnly: false,
    search: '',
  }
}

export function formatSort(sort) {
  return `${sort.key}:${sort.direction}`
}

export function nextSort(current, key) {
  if (current.key === key) {
    return { key, direction: current.direction === 'asc' ? 'desc' : 'asc' }
  }
  return { key, direction: 'asc' }
}
